import Link from 'next/link';
import { CypressI } from 'interfaces/cypress';
import { Typography } from 'components/common';
import { FooterLink, footerLinks } from 'const/footer';
import { FacebookIcon, InstagramIcon } from 'public/icons/tsx';
import { ContainerBase } from 'components/landing/containers';
import { useRouter } from 'next/router';
export interface Footer_Props {
	links?: {
		title: string;
		url: string;
	}[];

	companyName?: string;
	rightsYear?: string;
}

/**
 * General footer for the app
 *
 * @param links list to show in the footer
 * @returns JSX element representing the footer container
 */
const Footer: React.FC<Footer_Props & CypressI> = ({ dataCY }) => {
	const { company, learn } = footerLinks;
	const currentYear = new Date().getFullYear();

	return (
		<footer data-cy={dataCY}>
			<ContainerBase className="bg-white">
				<div className="flex flex-col justify-between border-b border-opacity-primary w-full pt-6 md:pt-14 pb-6 md:flex-row">
					<div className="flex-1 flex items-center justify-between md:items-start md:space-y-6">
						<div className="flex gap-4 w-full justify-center xl:justify-start">
							<Link
								href="https://www.facebook.com/claimmagic"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Follow us on Facebook"
							>
								<FacebookIcon className="w-6 h-6" />
							</Link>
							<Link
								href="https://www.instagram.com/claim_magic_ai/"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Follow us on Instagram"
							>
								<InstagramIcon className="w-6 h-6" />
							</Link>
						</div>
					</div>
					<div className="flex-1 flex flex-col items-center md:items-start justify-start gap-6 md:flex-row md:justify-end md:gap-16 lg:gap-40 mt-6 md:mt-0">
						<div>
							<Typography
								type="bold-18"
								text="Company"
								className="text-center md:text-left"
							/>
							<ul>
								{company.map((link) => (
									<li key={link.title} className="text-center md:text-left">
										<ItemToClick link={link} />
									</li>
								))}
							</ul>
						</div>
						<div>
							<Typography type="bold-18" text="Learn More" />
							<ul>
								{learn.map((link) => (
									<li key={link.title} className="text-center md:text-left">
										<ItemToClick link={link} />
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
				<div className="w-full flex items-center justify-center pt-7 pb-7 lg:pb-14">
					<Typography
						type="regular-14"
						className="opacity-60 !text-base md:!text-sm"
						text={`© ${currentYear} Claim Magic. All rights reserved.`}
					/>
				</div>
			</ContainerBase>
		</footer>
	);
};

export default Footer;

const ItemToClick: React.FC<{ link: FooterLink }> = ({ link }) => {
	const router = useRouter();
	if (link.onClick) {
		return (
			<button
				type="button"
				onClick={() => {
					link.onClick?.();
					link.url && router.push(link.url);
				}}
			>
				<Typography
					type="regular-16"
					text={link.title}
					className="opacity-60 !text-base md:!text-sm"
				/>
			</button>
		);
	} else {
		return (
			<Link href={link.url}>
				<Typography
					type="regular-16"
					text={link.title}
					className="opacity-60 !text-base md:!text-sm"
				/>
			</Link>
		);
	}
};
